import { Inject, Injectable, Optional } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CORE_LAYOUT_DARK_MODE_ENABLED } from '../tokens';

@Injectable({ providedIn: 'root' })
export class CoreDarkModeService {
  private _darkMode = new BehaviorSubject<boolean>(false);
  private _isEnable = new BehaviorSubject<boolean>(false);
  darkMode$ = this._darkMode.asObservable();
  isEnable$ = this._isEnable.asObservable();

  constructor(@Optional() @Inject(CORE_LAYOUT_DARK_MODE_ENABLED) private uxDarkModeEnabled: boolean) {
    this.setEnable(uxDarkModeEnabled);
    this._darkMode.next(localStorage.getItem('isCwcDarkMode') === 'true');
    document.documentElement.setAttribute(
      'cwc-theme',
      localStorage.getItem('isCwcDarkMode') === 'true' && uxDarkModeEnabled ? 'dark' : 'light',
    );
  }

  setDarkMode(data: boolean): void {
    const darkModeEnabled = document.documentElement.getAttribute('cwc-dark-mode-enabled');
    document.documentElement.setAttribute('cwc-theme', data && darkModeEnabled ? 'dark' : 'light');
    localStorage.setItem('isCwcDarkMode', data ? 'true' : 'false');
    this._darkMode.next(data);
  }

  setEnable(data: boolean): void {
    this._isEnable.next(data);
    if (data) {
      document.documentElement.setAttribute('cwc-dark-mode-enabled', 'true');
    } else {
      document.documentElement.removeAttribute('cwc-dark-mode-enabled');
      document.documentElement.setAttribute('cwc-theme', 'light');
    }
  }

  getCurrentTheme(): 'dark' | 'light' {
    const currentTheme = typeof document !== 'undefined' ? document.documentElement?.getAttribute('cwc-theme') : null;
    if (currentTheme === 'dark' || currentTheme === 'light') {
      return currentTheme;
    }
    const isDark =
      this._darkMode.value || (typeof localStorage !== 'undefined' && localStorage.getItem('isCwcDarkMode') === 'true');
    const isEnabled =
      this._isEnable.value ||
      (typeof document !== 'undefined' && document.documentElement?.getAttribute('cwc-dark-mode-enabled') === 'true');
    return isDark && isEnabled ? 'dark' : 'light';
  }
}
